import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import Gallery from "@/components/Gallery";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import Seo from "@/components/Seo";
import { useLang } from "@/context/LangContext";

export default function Home() {
  const { lang } = useLang();
  const [content, setContent] = useState(null);
  const [services, setServices] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const [c, s, g] = await Promise.all([
          api.get("/content"),
          api.get("/services"),
          api.get("/gallery"),
        ]);
        if (!active) return;
        setContent(c.data);
        setServices(s.data);
        setGallery(g.data);
      } catch (err) {
        toast.error(formatApiError(err));
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    return () => {
      active = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-afb-bg">
        <div className="text-afb-muted text-sm tracking-widest uppercase">
          Caricamento...
        </div>
      </div>
    );
  }

  return (
    <div className="bg-afb-bg" data-testid="home-page">
      <Seo content={content} />
      <Header
        manifestoEnabled={!!content?.manifesto_enabled}
        bookingEnabled={!!content?.booking_enabled}
        bookingLabel={
          lang === "en" ? content?.booking_label_en : content?.booking_label_it
        }
      />
      <main>
        <Hero content={content} />
        <Services services={services} />
        <About content={content} />
        <Gallery items={gallery} />
        <Contact content={content} />
      </main>
      <Footer content={content} />
      <WhatsAppFab content={content} />
    </div>
  );
}
